import {Endpoints} from '../../../../../globals/api/endpoints';

export class LegendEndpoints extends Endpoints {

  private static readonly LEGENDS = LegendEndpoints.VIEWER + '/legend';
  public static readonly LEGEND = LegendEndpoints.LEGENDS + '/' + LegendEndpoints.PROJECT_ID;
  public static readonly LEGEND_PREVIEW = LegendEndpoints.LEGENDS + '/' + LegendEndpoints.VERSION_ID + '/preview';
}
